var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-document',{attrs:{"standalone":""}},[_c('navigation',{attrs:{"items":_vm.items}}),_vm._v(" "),_c('lang-switcher'),_vm._v(" "),_c('nuxt'),_vm._v(" "),_c('portal-target',{attrs:{"name":"modals","multiple":""}}),_vm._v(" "),_c('notifications')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }